import { Redirect, Route } from "react-router-dom";
import { SimplePersistence } from "../utils";
import { SIGNIN_TOKEN } from "../constants";
import { useSelector } from "react-redux";

const storage = new SimplePersistence();
const isSignedIn = (user) => user && user.isSignedIn && !!storage.getItem(SIGNIN_TOKEN);

export const CustomRoute = (props) => {
  const user = useSelector((state) => state.user);
  const { component: Component, path, roles, match, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(prop) => {
        const mergedMatch = match ? { ...prop.match, ...match } : prop.match;
        if (!isSignedIn(user)) {
          return <Redirect to={{ pathname: "/login", state: { from: prop.location } }} />;
        }
        return <Component {...prop} match={mergedMatch} />;
      }}
    />
  );
};
